var exports = {
  "KF": "UserVoiceTab.module__sliderLabel___LWJXTG",
  "Gl": "UserVoiceTab.module__sliderLabelRow___LWJXTG",
  "Qg": "UserVoiceTab.module__audioProcessing___LWJXTG",
  "Om": "UserVoiceTab.module__audioProcessingCard___LWJXTG",
  "ZT": "UserVoiceTab.module__deviceNotice___LWJXTG",
  "ei": "UserVoiceTab.module__deviceNoticeText___LWJXTG",
  "dv": "UserVoiceTab.module__deviceNoticeTitle___LWJXTG",
  "H6": "UserVoiceTab.module__deviceNoticeDescription___LWJXTG",
  "Ov": "UserVoiceTab.module__pttSettings___LWJXTG",
  "jS": "UserVoiceTab.module__pttSettingRow___LWJXTG",
  "ps": "UserVoiceTab.module__pttSettingDescription___LWJXTG",
  "Np": "UserVoiceTab.module__profileSubSection___LWJXTG",
  "aG": "UserVoiceTab.module__sensitivitySliderWrapper___LWJXTG",
};

module.exports = exports;
